import { render } from "./IconExamList.vue?vue&type=template&id=44bbbd2a&lang=html"
import script from "./IconExamList.vue?vue&type=script&lang=js"
export * from "./IconExamList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__